import { mq } from "cssInJs"

export default {
  orderDetails: {
    textAlign: 'left',
    marginBottom: '3rem'
  },
  summary: {

  },

  fn: mq({
    minWidth: ['7rem', null, '10em'],
    margin: 0
  }),
  fv: {

  },

  orderItems: {},
  orderItem: {
    padding: '0.5rem 0',
    margin: '0.5rem 0',
    borderBottom: 'solid 1px #ccc',
    "&.hide" : {
      display: 'none'
    }
  },
  total: {
    marginLeft: 15,
    fontWeight: 'bold',
    color: 'chocolate'
  }
}